import React, { useEffect, useRef } from "react";
import {
  SVG_HOME,
  SVG_CITY_PROFILE,
  SVG_CHARTS,
  SVG_USER,
  SVG_INDICATORS,
  SVG_ABOUT,
  SVG_LOGIN,
  SVG_DASHBOARD,
  SVG_IMIS_CITY,
} from "../../../Assets/SVG/svg_util.js";
import { useNavContext } from "../../../Context Api/NavContext.js";
import LanguageToggle from "../../LanguageToggler.js";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isAuthenticated } from "../../../Helpers/authHelper.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import NavProfile from "../../NavProfile/index.js";
import { X } from 'lucide-react';

const Nav = React.memo(() => {
  const { isShowBurgerMenu, setShowBurgerMenu } = useNavContext();
  const isLoggedIn = isAuthenticated();
  const { t } = useTranslation();
  const location = useLocation();
  const navRef = useRef(null);

  const NAVS = [
    { name: "home", link: "home", icon: SVG_HOME },
    isLoggedIn && {
      name: "modules",
      link: "modules",
      icon: SVG_DASHBOARD,
    },
        { name: "city_profile", link: "city-profile", icon: SVG_CITY_PROFILE },
    { name: "charts", link: "charts", icon: SVG_CHARTS },

    { name: "indicators", link: "indicators", icon: SVG_INDICATORS },
    { name: "fstp", link: "fstp", icon: SVG_INDICATORS },
    {
      name: "imis-cities",
      link: "imis-cities",
      icon: SVG_IMIS_CITY,
    },
    { name: "about", link: "about", icon: SVG_ABOUT },
    { name: "login", link: "login", icon: SVG_LOGIN },
  ].filter(Boolean);

  const isDashboardActive = (path) => {
    const dashboardPaths = [
      "/modules",
      "/imis-dashboard",
      "/data-insertion",
      "/projects",
      "/add-project",
      "/manage-users",
      "/permission-manager/:id",
      "/add-user",
      "/add-imis-user",
      "/create-kii",
      "/manage-kii",
      "/manage-kii/dashboard",
      "/kii-data-submission",
      "/kii-data-submission-city-list",
      "/kii-questionnaire",
      "/select-kii-questionnaire-method",
      "/create-kii-questionnaire",
      "/view-kii-questionnaire",
      "/create-survey",
      "/manage-survey",
      "/manage-survey/dashboard",
      "/survey-data-submission",
      "/survey-data-submission-city-list",
      "/survey-questionnaire",
      "/select-survey-questionnaire-method",
      "/create-survey-questionnaire",
      "/view-survey-questionnaire",
      "/manage-cityprofile-data",
      "/insert-basic-data",
      "/insert-map-data",
    ];
    return dashboardPaths.some((dashPath) =>
      location.pathname.startsWith(dashPath)
    );
  };

  useEffect(() => {
    const handleClickOutSide = (event) => {
      const svgElement =
        event.target.closest("svg")?.getAttribute("data-icon") === "bars";

      if (
        navRef.current &&
        !navRef.current.contains(event.target) &&
        !svgElement
      ) {
        setShowBurgerMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutSide);
    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    };
  }, [isShowBurgerMenu, setShowBurgerMenu]);

  return (
    <nav
      ref={navRef}
      className={`
        lg:h-[calc(100vh-152px)] 
        md:h-[calc(100vh-200px)] 
       
        bg-white md:bg-transparent
        shadow-lg md:shadow-none
        transition-transform duration-300
        ${
          isShowBurgerMenu
            ? "translate-x-0"
            : "-translate-x-full md:translate-x-0"
        }
        flex flex-col border-e-2
        fixed md:sticky
        top-24 md:top-0
        bottom-0
        z-50
      `}
    >
              

  <button
    onClick={() => setShowBurgerMenu(false)}
    className="mt-2 mr-2 ml-auto flex items-center justify-center size-8  rounded-full border border-gray-300 text-red-500 hover:bg-red-100 hover:scale-110 transition-all duration-200 md:hidden"
  >
    <X size={18} />
  </button>




      <LanguageToggle />

      <div className="flex flex-col flex-grow min-h-0 ">
        <ul className="flex-grow space-y-4 flex-1 overflow-auto">
          {NAVS?.map((nav) => {
            const isActive =
              nav.link === "dashboard"
                ? isDashboardActive(location.pathname)
                : (location.pathname === "/city-comparison" ||
                    location.pathname === "/city-profile") &&
                  (nav.link == "city-profile")
                ? true
                : location.pathname.includes(nav.link) ||
                  (location.pathname === "/" && nav.link === "home");

            if (
              (nav.name === "login" && isLoggedIn) ||
              (nav.name === "imis-cities" && !isLoggedIn)
            ) {
              return null;
            }

            return (
              <Link
                key={nav.link}
                to={`/${nav.link}`}
                className="block"
                onClick={() => setShowBurgerMenu(false)}
              >
                <li
                  className={`
                    flex flex-col items-center gap-2
                    cursor-pointer
                    transition-colors
                    ${isActive ? "text-[#ff9f3cff]" : "text-gray-500"}
                    hover:text-[#ff9f3cff]
                  `}
                >
                  {typeof nav.icon === "function" ? (
                    nav.icon()
                  ) : (
                    <nav.icon className="h-6 w-6" />
                  )}
                  <span className="text-sm sm:text-base md:text-sm font-medium">
                    {t(`nav.${nav.name}`)}
                  </span>
                </li>
              </Link>
            );
          })}
        </ul>

        <div className="mt-auto">{isShowBurgerMenu && <NavProfile />}</div>
      </div>
    </nav>
  );
});

export default Nav;
